export interface ConsentDefinitionResponse {
  id: number
  name: string
  mandatory: boolean
  registrationSteps: Record<ConsentRegistrationType, number>
  defaultText: string
  canClientEdit: boolean
  brandAssignments: Record<string, ConsentBrandAssignment>
  parentName?: string
  version: number
}


export interface CreateConsentDefinitionRequest {
  key: string
  name: string
  mandatory: boolean
  defaultText: string
  canClientEdit: boolean
  parentName?: string
  registrationSteps: Record<ConsentRegistrationType, number>
  brandAssignment: Record<string, ConsentBrandAssignment>
}

export interface UpdateConsentDefinitionRequest {
  mandatory: boolean
  defaultText: string
  canClientEdit: boolean
  parentName?: string
  registrationSteps: Record<ConsentRegistrationType, number>
  brandAssignment: Record<string, ConsentBrandAssignment>
}

export enum ConsentRegistrationType {
  NEW = 'NEW',
  REPEATED = 'REPEATED'
}

export interface ConsentBrandAssignment {
  channelDetails: Record<ConsentConfigurationIdentifier, ConsentChannelDetails>
}

export interface ConsentChannelDetails {
  text: string
  collect: boolean
}

export enum ConsentConfigurationIdentifier {
  WEB = 'WEB',
  BACKOFFICE = 'BACKOFFICE',
  MARKETING = 'MARKETING',
  ADDITIONAL_AMOUNT = 'ADDITIONAL_AMOUNT'
}

export interface RegistrationStepsPair {
  consentRegistrationType: ConsentRegistrationType
  amount: number
}

export interface BrandAssignmentPair {
  brand: string
  channelDetails: ChannelDetailsForm[]
}

export interface ChannelDetailsForm {
  identifier: string
  text: string
  collect: boolean
}
